import { useState } from "react";
import { TopBar } from "../common/TopBar";
import { useNavigate } from "react-router";
import "./ForgetPasswordStyles.css";
import { LoginService } from "@propertelligent/client-api";
import apiHelper from "../../utils/apiHelper";
import CustomInputs from "../common/Inputs";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { useError } from "../../utils/context/ErrorContext";
import { checkEmptyFieldsFunc, validateEmail } from "../../utils/validateHelper";
import AddTraspButton from "../firstTimeUserExperience/commonCom/AddTraspButton";
import MobileAuthLink from "./MobileAuthLink";

export const ForgetPassword = () => {
  const navigate = useNavigate();
  const [emailValue, setEmailValue] = useState("");
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError()

  const backToLogin = () => { navigate("/login") };

  const sendResetLink = (e) => {
    e.preventDefault()
    if (checkEmptyFieldsFunc({ email: emailValue }, clearErrors, errors, errorMessages, setErrors, setErrorMessages, undefined)) {
    } else {
      apiHelper(LoginService.postApiLoginForgetPassword, { showNotification: false }, { email: emailValue })
        .then((res) => {
          const stateData = { key: emailValue }; // Your state data
          if (res?.data?.success) {
            navigate("/checkemail", { state: stateData });
          } else {
            if (errors.email == false) {
              navigate("/checkemail", { state: stateData });
            }
          }
        }).catch((error) => { });
    }
  };

  return (
    <>
      <div className="background-section background-image forget-password-page-container">
        <TopBar haveAccount="Don’t have an account?" signInUp="Sign up" />
        <div className="form-container-main p-3">
          <form onSubmit={sendResetLink} className="form-container flexFullColumn">
            <p className="top_header mb-2 black">Forgot Password</p>
            <p className="sub_heading fw-normal mb-4 grey_subtext1">
              Reset password link will be sent to your email address
            </p>
            <CustomInputs
              myClassName="forgetPasswordInput normal_text"
              labelText="Email"
              type="email"
              placeholder="Email address"
              value={emailValue}
              onChange={(e) => {
                setEmailValue(e.target.value);
                setErrors({ ...errors, email: false });
                setErrorMessages({ ...errorMessages, email: "" });
              }}
              isError={errors.email}
              onBlur={() => validateEmail(emailValue, setErrors, setErrorMessages)}
              errorMessages={errorMessages.email}
            />
            <AddButtonWithArrow className="sendPasswordButton sub_heading" type="submit" buttonname={"Send reset password link"} />
            <AddTraspButton className="w-100" bname="Back to login" border={false} onClick={backToLogin} />
            
            {/* Mobile Only Signup Link */}
            <MobileAuthLink variant="signup" />
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
